"use client";

import * as React from "react";
import {
  LayoutDashboard,
  Users,
  Car,
  Package,
  Calendar,
  RefreshCw,
  Receipt,
  BarChart3,
  UserCog,
  Settings,
  LogIn,
  LogOut,
  Activity,
} from "lucide-react";

import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarFooter,
} from "@/components/ui/sidebar";
import { Link, useLocation } from "react-router-dom";
import { Button } from "./ui/button";
import { authService } from "@/services/authService";
import { useAuth } from "@/context/AuthContext";

const menuItems = [
  {
    title: "Dashboard",
    icon: LayoutDashboard,
    href: "/",
  },
  {
    title: "Customers",
    icon: Users,
    href: "/customers",
  },
  {
    title: "Vehicles",
    icon: Car,
    href: "/vehicles",
  },
  {
    title: "Packages & Add-ons",
    icon: Package,
    href: "/packages",
  },
  {
    title: "Appointments",
    icon: Calendar,
    href: "/appointments",
  },
  {
    title: "Subscriptions",
    icon: RefreshCw,
    href: "/subscriptions",
  },
  {
    title: "Billing & Invoices",
    icon: Receipt,
    href: "/billing",
  },
  {
    title: "Reports",
    icon: BarChart3,
    href: "/reports",
  },
  {
    title: "Staff",
    icon: UserCog,
    href: "/staff-management",
  },
  // {
  //   title: "Settings",
  //   icon: Settings,
  //   href: "/settings",
  // },
  {
    title: "Activity",
    icon: Activity,
    href: "/activity",
  },
];

export function AppSidebar() {
  const { logout } = useAuth();
  const location = useLocation();

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader className="border-b px-6 py-5">
        <div className="flex items-center gap-3">
          <img src="/assets/images/logo.svg" alt="WeClean" className="" />
        </div>
      </SidebarHeader>
      <SidebarContent className="px-3 py-4">
        <SidebarMenu>
          {menuItems.map((item) => {
            const isActive = location.pathname === item.href;

            return (
              <SidebarMenuItem key={item.title}>
                <SidebarMenuButton
                  asChild
                  isActive={isActive}
                  tooltip={item.title}
                  className="h-10 px-3"
                >
                  <Link to={item.href}>
                    <item.icon className="h-4 w-4 shrink-0" />
                    <span className="text-sm truncate">{item.title}</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            );
          })}
        </SidebarMenu>
      </SidebarContent>
      <SidebarFooter className="border-t p-4">
        <SidebarMenuButton
          onClick={() => {
            logout();
          }}
        >
          <LogOut className="mr-2 h-4 w-4 text-red-500" />
          <span className="hidden sm:inline text-red-500">Logout</span>
        </SidebarMenuButton>
      </SidebarFooter>
    </Sidebar>
  );
}
